import logisticsComponent from './logistics.component';

const logisticsModule = angular.module('app.components.logistics', [])
	.component('logistics', logisticsComponent)
	.name;

export default logisticsModule;
